import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';

import { Observable, Subscription, filter } from 'rxjs';
import { Site } from 'src/app/model/site';
import { Scenery } from 'src/app/model/scenery';
import * as SceneryActions from 'src/app/store/scenery/scenery.actions';
import {selectSceneryAdded, selectSceneryAdding, selectSceneryEdited, selectSceneryEditing } from 'src/app/store/scenery/scenery.selector';
import { StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	templateUrl: './scenery.dialog.component.html',
})

export class SceneryDialogComponent implements OnInit, OnDestroy {
	added$: Observable< number | undefined >;
	addedSub: Subscription | undefined;
	adding$: Observable< boolean | undefined >;
	addingSub: Subscription | undefined;
	edited$: Observable< boolean | undefined >;
	editedSub: Subscription | undefined;
	editing$: Observable< boolean | undefined >;
	editingSub: Subscription | undefined;

	addSceneryForm: FormGroup;
	add = true;

	added: number;
	adding: boolean;
	edited: boolean;
	editing: boolean;

	site: Site;
	scenery?: Scenery;

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		if (config.data !== undefined && config.data.site !== undefined) {
				this.site = config.data.site;
		}
		if (config.data !== undefined && config.data.scenery !== undefined) {
				this.scenery = config.data.scenery;
				this.adding = false;
		} else {
				this.scenery = new Scenery(this.site.Id);
		}
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	buildForm(): void {
		this.addSceneryForm = new FormGroup({
				'name': new FormControl(this.scenery.Name, Validators.required),
				'description': new FormControl(this.scenery.Description, Validators.required),
		});
	}

	initSelectors(): void {
		this.added$ = this.store.select(selectSceneryAdded);
		this.adding$ = this.store.select(selectSceneryAdding);
		this.edited$ = this.store.select(selectSceneryEdited);
		this.editing$ = this.store.select(selectSceneryEditing);
	}

	subscribeAll(): void {
		this.addedSub = this.added$?.pipe(filter((added) => !!added))
			.subscribe((added) => {
				this.resetClose();
				this.added = added;
			});
		this.addingSub = this.adding$?.subscribe((adding) => {
				this.adding = adding;
		});
		this.editedSub = this.edited$?.pipe(filter((edit) => !!edit))
			.subscribe((edited) => {
				this.resetClose();
				this.edited = edited;
			});
		this.editingSub = this.editing$?.subscribe((editing) => {
				this.editing = editing;
		});
	}

	ngOnDestroy(): void {
		this.addedSub?.unsubscribe();
		this.addingSub?.unsubscribe();
		this.editedSub?.unsubscribe();
		this.editingSub?.unsubscribe();
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.addSceneryForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.addSceneryForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		const name = this.f.name.value;
		const description = this.f.description.value;

		this.scenery = {
			...this.scenery,
			Name: name,
			Description: description,
	  };
	  if (this.scenery.Id) {
			this.store.dispatch(SceneryActions.editScenery({ scenery: this.scenery }));
	  } else {
			this.store.dispatch(SceneryActions.addScenery({ scenery: this.scenery }));
	  }
	}

	get f(): any {
		return this.addSceneryForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	resetClose(): void {
		this.store.dispatch(SceneryActions.resetSceneryDialog());
		this.closeDialog();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth,'w-20rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	// Errors management & Design Border | Input
	showErrorInvalidMessage(type: SceneryDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	showErrorConfirmInvalidMessage(type: SceneryDialogComponent['f'], notEquivalentType: string): boolean {
		return StandardNewValidator.showErrorConfirmInvalidMessage(type,notEquivalentType,this.addSceneryForm);
	}

	newShowErrors(type: SceneryDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type,classType,this.screenWidth);
	}

	showErrorsConfirmFields(type: SceneryDialogComponent['f'],classType: string,notEquivalentType: string): string {
		return StandardNewValidator.showErrorsConfirmFields(type,classType,notEquivalentType,this.screenWidth,this.addSceneryForm);
	}

	showErrorRequiredMessage(type: SceneryDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}
}
